// Shared sidebar collapse state — owned by localStorage, synced between the
// Header (chevron toggle) and the Sidebar (rail width) via a window event.

export const SIDEBAR_COLLAPSE_KEY = 'ilearn_sidebar_collapsed';
export const SIDEBAR_COLLAPSE_EVENT = 'ilearn:sidebar-collapse';

export function getSidebarCollapsed(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setSidebarCollapsed(next: boolean): void {
  try {
    localStorage.setItem(SIDEBAR_COLLAPSE_KEY, String(next));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(
    new CustomEvent(SIDEBAR_COLLAPSE_EVENT, { detail: { collapsed: next } })
  );
}

export function toggleSidebarCollapsed(): void {
  setSidebarCollapsed(!getSidebarCollapsed());
}
